import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";

import { Alert, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import useScript from "lib/useScript";

const CLIENT_ID =
  "843938410143-ot18gqcgm62sanhiqqckjj15q07boot2.apps.googleusercontent.com";

const MUTATION = gql`
  mutation Auth_GmailGrant_GmailGrant($code: String!) {
    GmailGrant(code: $code) {
      user {
        id
        gmail {
          isLinked
        }
      }
    }
  }
`;

export default function GmailGrant({ user }) {
  const [gmailGrant, { error, loading }] = useMutation(MUTATION);

  const handleClick = React.useCallback(
    async (event) => {
      const res = await window.gapi.auth2.getAuthInstance().grantOfflineAccess({
        scope: ["https://mail.google.com/"].join(" "),
      });

      await gmailGrant({ variables: { code: res.code } });
    },
    [gmailGrant]
  );

  const [loaded] = useScript("https://apis.google.com/js/api.js");

  React.useEffect(() => {
    if (!loaded) return;

    window.gapi.load("auth2", () => {
      window.gapi.auth2.init({ client_id: CLIENT_ID });
    });
  }, [loaded]);

  if (user.gmail.isLinked)
    return (
      <Alert severity="success">
        <Typography color="inherit">
          Ton compte <em>Gmail</em> est tracké, je peux lire tous tes mails 🥰
        </Typography>
      </Alert>
    );

  return (
    <>
      <Alert severity="error">
        <Typography color="inherit">
          Ton compte <em>Gmail</em> n’est pas tracké, je ne peux pas lire tes
          mails 🤬
          <br />
          Si le problème persiste, tu doit surement réinitialiser l’autorisation
          Lapidou{" "}
          <a
            href="https://myaccount.google.com/permissions"
            target="_blank"
            rel="noopener noreferrer"
          >
            ici
          </a>
          .
        </Typography>
      </Alert>

      {error && <Alert severity="error">{error.toString()}</Alert>}

      <LoadingButton
        loading={loading}
        onClick={handleClick}
        style={{ marginTop: 16 }}
      >
        Google
      </LoadingButton>
    </>
  );
}

GmailGrant.fragments = {
  user: gql`
    fragment GmailGrant_user on User {
      id
      gmail {
        isLinked
      }
    }
  `,
};
